<template>
  <div>
      <!-- 面包屑：名称与菜单配置同步 -->
    <AppBreadcrumb :items="[{ label: '位置管理' }, { label: '小区信息' }]" />
    <div class="commbtn">
        <el-button @click="commvisble">添加小区</el-button>
    </div>
    <!-- table表格 -->
    <div class="tab">
      <el-card>
    <el-table :data="tableData" size=mini highlight-current-row :header-cell-style = "{background:'#987AFF'}" height='500'>
    <el-table-column type="index" width="40" />
    <el-table-column property="name" label="小区名称" :show-overflow-tooltip="true" />
    <el-table-column property="valve" label="操作" >
      <template slot-scope="scope">
        <el-button size="mini" @click="ficati(scope.row)">修改</el-button>
        <el-button size="mini" @click="opens(scope.row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
      </el-card>
    </div>
      <!-- 添加弹框 -->
  <div class="locationAdd">
  <el-dialog title="信息编辑" :visible.sync="dialogFormVisible" width="20%">
  <el-form :model="Locatw">
    <el-form-item label="小区名称 : " :label-width="formLabelWidth">
      <el-input v-model="Locatw.name" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="Locationt"><i class="el-icon-document" />保存</el-button>
  </div>
</el-dialog>
</div>
<!-- 修改弹框 -->
  <div class="locationAdd">
  <el-dialog title="信息修改" :visible.sync="commfication" width="20%">
  <el-form :model="modify">
    <el-form-item label="小区名称 : " :label-width="formLabelWidth">
      <el-input v-model="modify.name" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="Locaficat"><i class="el-icon-document" />保存</el-button>
  </div>
</el-dialog>
</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogFormVisible: false,
      commfication: false,
      tableData: [],
      comities: {
        token: null
      },
      formLabelWidth: '100px',
      // 添加参数
      Locatw: {
        token: null,
        name: null
      },
      xigai: null,
      modify: {
        token: null,
        name: null,
        community_id: null
      },
      deleteloca: {
        token: null,
        community_id: null
      }
    }
  },
  created () {
    this.coomun()
  },
  methods: {
    //   添加按钮
    commvisble () {
      this.dialogFormVisible = true
    },
    Locationt () {
      this.Locatw.token = this.$store.state.print.goodsForeNo.token
      this.$api.Location.putcommunities(this.Locatw).then((res) => {
        console.log(res, '添加')
        if (res.data.status === 'success') {
          this.coomun()
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
      this.dialogFormVisible = false
      this.Locatw.name = null
    },
    // 修改按钮
    ficati (row) {
      console.log(row)
      this.xigai = row.id
      this.commfication = true
    },
    Locaficat () {
      this.modify.token = this.$store.state.print.goodsForeNo.token
      this.modify.community_id = this.xigai
      this.$api.Location.postcommunities(this.modify).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '修改')
          this.coomun()
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
      this.commfication = false
      this.modify.name = null
    },
    // 删除
    opens (row) {
      this.deleteloca.token = this.$store.state.print.goodsForeNo.token
      this.deleteloca.community_id = row.id
      this.$confirm('此操作将永久删除该位置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.Location.deletecommunities(this.deleteloca).then((res) => {
          if (res.data.status === 'success') {
            console.log(res, '删除')
            this.coomun()
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
          } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // table
    coomun () {
      this.comities.token = this.$store.state.print.goodsForeNo.token
      this.$api.userProfile.communities(this.comities).then((res) => {
        console.log(res.data.data, '获取小区')
        this.tableData = res.data.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* // 面包屑 */
.Gnv {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  font-size: 19px;
  letter-spacing: 1px;
  //   font-family: myFont;
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 75px;
    .yai{
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }
    ::v-deep .el-breadcrumb__item{
      margin-left: 0px;
      .el-breadcrumb__inner.is-link{
        font-weight: 100;
        color: #656d92;
  }
    }
  }
}
// 添加按钮
.commbtn{
    padding: 20px 0px 0px 74px;
    .el-button {
      background-color: #744dfe;
      border: 0px;
      color: #fff;
    }
}
.locationAdd{
  .el-form{
    .el-form-item{
      .el-input{
        width: 200px;
      }
    }
  }
}
// <!-- table表格 -->
    .tab{
        padding: 30px 30px 0px 74px;
        // 分页
        .el-pagination{
          ::v-deep .el-pagination__rightwrapper{
            float: left;
            margin-left: 20px;
          }
        }
        .el-card{
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table tr{
            background-color: #F9F9F9;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
        }
    }
</style>
